export default "__VITE_ASSET__369f065c__"